export default "__VITE_ASSET__BZMkn6j7__"